import type {
  EventActionResponse,
  EventCancelResponse,
  EventCreateRequest,
  EventDto,
  EventUpdateRequest,
  EventsListResponse,
} from '../../api/types';
import type { EventsRepository } from '../../repositories/ApiEventsRepository';

export class EventsService {
  constructor(private readonly repo: EventsRepository) {}

  getEvent(params: { eventId: string }): Promise<EventDto> {
    return this.repo.getEvent(params);
  }

  listEventsRange(params: { from: string; to: string }): Promise<EventsListResponse> {
    return this.repo.listEventsRange(params);
  }

  listEventsDate(params: { date: string }): Promise<EventsListResponse> {
    return this.repo.listEventsDate(params);
  }

  createEvent(params: { payload: EventCreateRequest }): Promise<EventDto> {
    return this.repo.createEvent(params);
  }

  updateEvent(params: { eventId: string; payload: EventUpdateRequest }): Promise<EventDto> {
    return this.repo.updateEvent(params);
  }

  cancelEvent(params: { eventId: string }): Promise<EventCancelResponse> {
    return this.repo.cancelEvent(params);
  }

  joinEvent(params: { eventId: string }): Promise<EventActionResponse> {
    return this.repo.joinEvent(params);
  }

  leaveEvent(params: { eventId: string }): Promise<EventActionResponse> {
    return this.repo.leaveEvent(params);
  }

  confirmEvent(params: { eventId: string }): Promise<EventActionResponse> {
    return this.repo.confirmEvent(params);
  }

  inviteToEvent(params: { eventId: string; telegramIds: number[] }): Promise<EventDto> {
    return this.repo.inviteToEvent(params);
  }

  inviteGroupToEvent(params: { eventId: string; groupId: string }): Promise<EventDto> {
    return this.repo.inviteGroupToEvent(params);
  }

  removeFromEvent(params: { eventId: string; telegramIds: number[] }): Promise<EventDto> {
    return this.repo.removeFromEvent(params);
  }

  unreserveFromEvent(params: { eventId: string; telegramIds: number[] }): Promise<EventDto> {
    return this.repo.unreserveFromEvent(params);
  }
}
